import { render, staticRenderFns } from "./StudentManager.vue?vue&type=template&id=34bc0934&"
import script from "./StudentManager.vue?vue&type=script&lang=js&"
export * from "./StudentManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports